import { render, staticRenderFns } from "./r-alertas-bell.vue?vue&type=template&id=26458d94&scoped=true"
import script from "./r-alertas-bell.vue?vue&type=script&lang=js"
export * from "./r-alertas-bell.vue?vue&type=script&lang=js"
import style0 from "./r-alertas-bell.vue?vue&type=style&index=0&id=26458d94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26458d94",
  null
  
)

export default component.exports